export const schema = {
    "models": {
        "Flyer": {
            "syncable": true,
            "name": "Flyer",
            "pluralName": "Flyers",
            "attributes": [
                {
                    "type": "model",
                    "properties": {}
                }
            ],
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "title": {
                    "name": "title",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "contact": {
                    "name": "contact",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "startDate": {
                    "name": "startDate",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": true,
                    "attributes": []
                },
                "endDate": {
                    "name": "endDate",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": true,
                    "attributes": []
                },
                "address": {
                    "name": "address",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "tel": {
                    "name": "tel",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "permalink": {
                    "name": "permalink",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "images": {
                    "name": "images",
                    "isArray": true,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "sponsor": {
                    "name": "sponsor",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "status": {
                    "name": "status",
                    "isArray": false,
                    "type": {
                        "enum": "FlyerStatus"
                    },
                    "isRequired": true,
                    "attributes": []
                }
            }
        }
    },
    "enums": {
        "FlyerStatus": {
            "name": "FlyerStatus",
            "values": [
                "TO_BE_CREATED",
                "CREATED",
                "TO_BE_UPDATED",
                "UPDATED",
                "TO_BE_DALETED",
                "DELETED"
            ]
        }
    },
    "version": "5a2c6b409d819a9a6e2bc105424ea834"
};